import { Replay } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import useConfirm from '../hooks/useConfirm';
import ConfirmModal from './modals/ConfirmModal';

interface ResetPopulationProps {
  onConfirm: () => void;
}

export default function ResetPopulation({ onConfirm }: ResetPopulationProps) {
  const { confirmOpen, confirmMessage, showConfirm, closeConfirm } = useConfirm();

  const clickHandler = () => showConfirm("Do you really want to wipe your images and start again? There is no going back.");

  return (
    <>
      <IconButton onClick={clickHandler} sx={{ marginLeft: '0px' }}>
        <Replay />
      </IconButton>
      <ConfirmModal onConfirm={onConfirm} open={confirmOpen} onClose={closeConfirm} message={confirmMessage} />
    </>
  );
};

